import React from 'react'

type Props = {
  availSince?: number | null
  className?: string
}

/**
 * Bloc d'information precommande pour fiche produit : explique que le produit
 * est en precommande, donne la date de livraison estimee, et rappelle le
 * paiement SEPA differe 30j apres expedition. Cles i18n :
 *  - web_precommande_product_info
 *  - web_precommande_delivery_on (avec [date])
 *  - web_precommande_payment_info
 */
const PrecommandeInfo: React.FC<Props> = ({ availSince, className = '' }) => {
  const hasDate = !!availSince && availSince > 0
  const formattedDate = hasDate
    ? new Date(availSince * 1000).toLocaleDateString('fr-FR')
    : null

  return (
    <div
      className={`border-l-4 border-amber-600 bg-amber-50 px-4 py-3 rounded-r-md ${className}`}
    >
      <div className="flex items-start gap-2">
        <span className="text-xs font-semibold uppercase tracking-wide text-white bg-amber-600 rounded-md px-2 py-1 whitespace-nowrap">
          {t({ id: 'web_precommande_badge' })}
        </span>
      </div>
      <p className="mt-2 text-sm text-amber-900 font-medium">
        {t({ id: 'web_precommande_product_info' })}
      </p>
      {hasDate && formattedDate && (
        <p className="mt-1 text-sm text-amber-800">
          {t({ id: 'web_precommande_delivery_on' }).replace('{date}', formattedDate)}
        </p>
      )}
      <p className="mt-1 text-xs text-amber-700 italic">
        {t({ id: 'web_precommande_payment_info' })}
      </p>
    </div>
  )
}

export default PrecommandeInfo
